import { createZustandShallowStore } from '@/lib/zustand';
import { SetStoreState, storeStateResolver } from '@/types/use';

interface CustomerSidebarState {
    isShowSidebar: boolean;
    setIsShowSidebar: (open: boolean) => void;

    isShowMenuOverlay: boolean;
    setIsShowMenuOverlay: SetStoreState<boolean>;
}

export const useCustomerSidebarStore =
    createZustandShallowStore<CustomerSidebarState>((set, get) => {
        return {
            isShowSidebar: true,
            isShowMenuOverlay: false,
            setIsShowSidebar: (open: boolean) => set({ isShowSidebar: open }),
            setIsShowMenuOverlay: (fn) =>
                set((st) => ({
                    isShowMenuOverlay: storeStateResolver(
                        st.isShowMenuOverlay,
                        fn
                    ),
                })),
        };
    });
